<script setup lang="ts">
import PhotoSwipe from "photoswipe/dist/photoswipe"
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default"
import "photoswipe/dist/photoswipe.css"
import "photoswipe/dist/default-skin/default-skin.css"

import { onBeforeMount, ref, toRaw, watch } from "vue"
import { nextTick } from "vue"

import { type Attachment } from "@/models/article"

interface Props {
  slides?: Attachment[]
}
const props = withDefaults(defineProps<Props>(), {
  slides: () => []
})

const options = {
  tapToClose: false,
  clickToCloseNonZoomable: false,
  pinchToClose: false,
  closeOnScroll: false,
  closeOnVerticalDrag: false,
  tapToToggleControls: false,
  closeElClasses: [],
  escKey: false,
  focus: false,
  index: 0,
  history: false,
  modal: false,
  closeEl: false,
  fullscreenEl: false,
  shareEl: false,
  errorMsg: `
    <div class="pswp__error-msg">
      <div class="text-black">Si è verificato un errore durante il caricamento.</div>
      <a href="#" onclick="window.location.reload()">
        <span class="text-black underline">Ricarica<span>
      </a>
    </div>
  `
}
const gallery = ref<PhotoSwipe | null>(null)

const initGallery = () => {
  if (!props.slides.length) return

  nextTick(() => {
    const pswpElement = document.querySelector(".pswp")

    gallery.value = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, toRaw(props.slides), options)
    gallery.value?.init()
  })
}

onBeforeMount(initGallery)
watch(() => props.slides, initGallery)
</script>

<template>
  <div ref="pswp" class="pswp relative" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>

    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>

          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>

        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pswp__bg {
  background: #cdcdcd;
}

.pswp {
  z-index: 10;
}
</style>
